import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root"
})
export class TipoMotivoService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getTipoMotivo(idTipoMotivo): Observable<any> {
    const url =
      Constants.BASE_URL + Constants.URL_TIPO_MOTIVO + "/" + idTipoMotivo;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Motivo",
            text: "Error Cargando Tipo Motivo.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public postTipoMotivo(params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_TIPO_MOTIVO;
    return this.http.post<any>(url, params).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Motivo",
            text: "Verifique la informacion ingresada.",
            type: "error",
            confirmButtonColor: "#127570"
          });
        }

        return throwError(err);
      })
    );
  }

  public putTipoMotivo(idTipoMotivo, params): Observable<any> {
    const url =
      Constants.BASE_URL + Constants.URL_TIPO_MOTIVO + "/" + idTipoMotivo;
    return this.http.put<any>(url, params).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Motivo",
            text: "Error actualizando información del tipo motivo.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }

  public deleteTipoMotivo(idTipoMotivo, usuario): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_TIPO_MOTIVO +
      "/" +
      idTipoMotivo +
      "/" +
      usuario;
    return this.http.delete<any>(url).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Motivo",
            text: "Error eliminado información del tipo motivo.",
            type: "error"
          });
        }

        return throwError(err);
      })
    );
  }
}
